import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { sendAnalyticsEvents } from '../../analytics/common';
import { EVENTS } from '../../analytics/events';
import AppButton from '../../components/AppButton';
import { selectEventsData } from '../../store/events';
import { selectWebp } from '../../store/ui';
import AppTitle from '../../components/AppTitle';
import AppSubtitle from '../../components/AppSubtitle';
import useImagesSrc from '../../hooks/useImagesSrc';
import { selectLandingAnimation } from '../../store/plans';
import useWindowWidth from '../../hooks/useWindowWidth';
import { usePreloadImages } from '../../hooks/useImagePreloader';

const StyledImage = styled.div`
  background-image: ${({ imgSource }) => imgSource && `url('${imgSource}')`};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  width: 100vw;
  max-height: 300px;
  height: 100%;
  @media screen and (min-width: 376px) {
    background-image: ${({ imgSource }) => imgSource && `url('${imgSource}')`};
    max-height: 512px;
    background-size: ${({ isAnim }) => (isAnim ? '100%' : '180%')};
    background-position: right;
  }
  @media screen and (min-width: 450px) {
    background-size: contain;
    background-position: center;
    min-height: 150px;
  }
`;

const StyledContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  // max-height: 80px;
  min-height: 150px;
  min-width: 330px;
  margin-bottom: 34px;
  @media screen and (min-width: 450px) {
    margin-bottom: 20px;
  }
`;

const CrashDetection = () => {
  const navigate = useNavigate();
  const eventsData = useSelector(selectEventsData);
  const { t } = useTranslation();
  const isWebp = useSelector(selectWebp);
  const { imagesSources } = useImagesSrc();
  const isAnimationLanding = useSelector(selectLandingAnimation);
  const windowWidth = useWindowWidth();
  usePreloadImages(imagesSources.speedControl);
  useEffect(
    () => sendAnalyticsEvents(EVENTS.onboardingCrashDetection, eventsData),
    [eventsData]
  );

  const onContinueClick = () => {
    sendAnalyticsEvents(EVENTS.onboardingCrashDetectionSubmitted, eventsData);
    navigate('/speed-control');
  };

  const imgSource = isAnimationLanding
    ? '../assets/desktop/anim/Crash_detection.gif'
    : windowWidth > 375 && isWebp
    ? '../assets/desktop/webp/Crash_detection.webp'
    : windowWidth > 375 && !isWebp
    ? '../assets/desktop/png/Crash_detection.png'
    : windowWidth < 375 && isWebp
    ? '../assets/mobile/webp/Crash_detection.webp'
    : '../assets/mobile/png/Crash_detection.png';

  return (
    <>
      <StyledImage imgSource={imgSource} isAnim={isAnimationLanding} />
      <StyledContent>
        <AppTitle
          title={t('crash_detection')}
          marginContainer={'0px 0px 12px 0px'}
        />
        <AppSubtitle subtitle={t('crash_detection_description')} />
      </StyledContent>
      <AppButton
        onClick={onContinueClick}
        bottomPosition={'24px'}
        customBeforeBg={'none'}
      >
        {t('continue')}
      </AppButton>
    </>
  );
};

export default CrashDetection;
